import {CheckCircleFillIcon, ChevronDownIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import styles from './CondensedMergeStatus.module.css'

/** Merge-status checklist in the sidebar */
export function CondensedMergeStatus() {
  return (
    <section aria-label="Merge status">
      <div className={styles.header}>
        <h4 className={styles.sectionTitle}>Merge status</h4>
        <IconButton icon={ChevronDownIcon} aria-label="Expand merge status" variant="invisible" size="small" />
      </div>
      <ul className={styles.statusList}>
        <li className={styles.statusRow}>
          <span className={styles.statusDotPending} />
          <span className={styles.statusText}>
            Waiting for approvals <span className={styles.statusDetail}>NN approvals</span>
          </span>
        </li>
        <li className={styles.statusRow}>
          <CheckCircleFillIcon size={16} fill="var(--fgColor-success)" />
          <span className={styles.statusText}>
            All checks passed <span className={styles.statusDetail}>NN/NN</span>
          </span>
        </li>
        <li className={styles.statusRow}>
          <CheckCircleFillIcon size={16} fill="var(--fgColor-success)" />
          <span className={styles.statusText}>No conflicts with base branch</span>
        </li>
      </ul>
    </section>
  )
}
